import React from "react";
import pClasses from "../Home.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export default function TabSecondEvaluation() {
  const { t } = useTranslation();
  const history = useNavigate();
  return (
    <section className={pClasses.TabSecondEvaluation}>
      <ButtonsArea>
        <RoundButton
          text={t("global.start_reevaluation")}
          title={t("global.start_reevaluation")}
          onClick={() => {history('/testes')}}
        />
      </ButtonsArea>
    </section>
  );
}
